module.exports = __webpack_public_path__ + "img/icon.a163b544.png";